import { env } from '@/config/environment';
import styles from './DevBanner.module.css';

export function DevBanner() {
  if (!env.isDev) return null;
  return (
    <div className={styles.banner} role="status" aria-label="Development environment">
      DEV ADMIN
    </div>
  );
}
